const Ticket = props => {
    return (
        <>
            <div className="ticket">
                <div className="issueType">
                    {props.regarding}
                </div>
                <div className="wrapper">

                    <div className="ticket-heading">
                        <span>TicketID</span>
                        <span className="ticketId">{props.ticketId}</span>
                    </div>
                    {props.ticketResolution ?
                        <div className="ticket-body">
                            <span>{props.ticketResolution?.text}</span>
                            <span className="ticketreg">{props.ticketResolution?.value}</span>
                        </div>
                        : ''}

                </div>
            </div>
        </>
    )
}
export default Ticket